import clsx from 'clsx';
import React from 'react';

import MyTISectionHeader from './SectionHeader';
import type { MyTISectionProps } from './interfaces';

const MyTISection = ({
  children,
  disableBorder = false,
  highlight,
  id,
  subtitle,
  title,
}: MyTISectionProps) => {
  return (
    <article
      className={clsx(
        'mt-48 scroll-mt-56 border-0 sm:mt-80 nav:scroll-mt-64',
        !disableBorder && 'border-t border-solid border-grayscale-gray pt-48 sm:pt-80'
      )}
      id={id}
    >
      <MyTISectionHeader highlight={highlight} subtitle={subtitle} title={title} />
      {children}
    </article>
  );
};

export default MyTISection;
